// TextListPanel — shared header dropdown panel for text-only menus.
// Used by AdmissionsPanel, WhyPanel, StudentLifePanel, and FinancialAidPanel
// to remove the four-way duplication that built up in Header.jsx. Each call
// site only specifies what's actually different: testIdPrefix, items, width,
// and an optional `footer` slot (Admissions uses this for the Download App
// button when the install prompt is available).
//
// Items take the same `{label, to, external?}` shape used elsewhere in
// Header.jsx. External items render as `<a target="_blank">`, internal ones
// as `<Link>`.
import { Link } from "react-router-dom";

const slugify = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const TextListPanel = ({ testIdPrefix, items, width = 320, footer = null }) => (
  <div
    className="absolute right-0 top-full mt-0 pt-3"
    style={{ width: `${width}px` }}
    data-testid={`mega-dropdown-${testIdPrefix}`}
  >
    <div className="bg-white shadow-[0_30px_60px_-20px_rgba(0,0,0,0.25)] border border-[var(--ac-line)] rounded-lg overflow-hidden p-5">
      <ul className="space-y-1">
        {items.map((a) => {
          const key = slugify(a.label);
          const baseCls = "block py-2 text-[15px] hover:text-[var(--ac-red)] font-medium transition";
          const cls = a.featured
            ? `${baseCls} text-[var(--ac-red)] font-bold`
            : `${baseCls} text-[var(--ac-ink)]`;
          return (
            <li key={`${a.label}-${a.to}`} data-testid={`mega-${testIdPrefix}-${key}`}>
              {a.external ? (
                <a href={a.to} target="_blank" rel="noopener noreferrer" className={cls}>
                  {a.label}
                </a>
              ) : (
                <Link to={a.to} className={cls}>
                  {a.label}
                </Link>
              )}
            </li>
          );
        })}
        {footer}
      </ul>
    </div>
  </div>
);

export default TextListPanel;
